module.exports = __webpack_public_path__ + "img/Gallery.a9c18c44.png";